import { useMutation } from "@tanstack/react-query";
import { notificationsService } from "../../../api/services/notifications";
import type { 
  NotificationSubscriptionRequest,
  NotificationUnsubscribeRequest,
  ContactMessageRequest,
} from "../../../api/services/notifications";

/**
 * Hook to subscribe to event notifications
 * Authenticated users: No email required, subscription linked to user UUID
 * Non-authenticated users: Must provide email address
 */
export const useSubscribeToNotifications = () => {
  return useMutation({
    mutationFn: (data?: NotificationSubscriptionRequest) => 
      notificationsService.subscribe(data),
  });
};

/**
 * Hook to unsubscribe from event notifications
 * Removes an email from receiving event notifications
 */
export const useUnsubscribeFromNotifications = () => {
  return useMutation({
    mutationFn: (data: NotificationUnsubscribeRequest) => 
      notificationsService.unsubscribe(data),
  });
};

/**
 * Hook to send contact message to support
 * Sends a message to Anchor Ingressos support team (ajuda@anchoringressos.com.br)
 */
export const useSendContactMessage = () => {
  return useMutation({
    mutationFn: (data: ContactMessageRequest) => 
      notificationsService.contact(data),
  });
};
